import React from 'react';
import Hero from './Hero/Hero';
import About from './About/About';
import Projects from './Projects/Projects';
import Blog from './Blog/Blog';
import Contact from './Contact/Contact';
import Footer from './Footer/Footer';

import { PortfolioProvider } from '../context/context';

import { heroData, aboutData, projectsData, blogData, contactData, footerData } from '../mock/data';

function App() {
  return (
    <PortfolioProvider
      value={{
        hero: heroData,
        about: aboutData,
        projects: projectsData,
        blog: blogData,
        contact: contactData,
        footer: footerData,
      }}
    >
      <Hero />
      <About />
      <Projects />
      <Blog />
      <Contact />
      <Footer />
    </PortfolioProvider>
  );
}

export default App;
